import React, {Component} from "react"
import {Form, FormInput, Checkbox, InputGroup, Button} from "elemental"
import {browserHistory} from "react-router"
import {translate} from "translate"
import app from "../../app.controller"

class SearchBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      search: app.state.search
    }
  }

  handleSearchSubmit = event => {
    let path = `/search?q=${this.state.search.q}`
    browserHistory.push(path)
    event.preventDefault()
  }

  handleSearchChange = event => {
    // console.log(`search`, event.target.value)
    app.search.change.dispatch({q: event.target.value})
    this.setState({search: {q: event.target.value}})
    if (browserHistory.getCurrentLocation().pathname !== '/search') {
      let path = `/search?q=${event.target.value}`
      browserHistory.push(path)
    }
  }

  render() {
    const t = this.props.t;
    return (
      <Form onSubmit={this.handleSearchSubmit}
            className="search-bar">
        <InputGroup contiguous>
          <InputGroup.Section>
            <Button submit
                    style={{
                      width: "42px", padding: "0 7px"
                    }}><i className="icon icon-search "/></Button>
          </InputGroup.Section>
          <InputGroup.Section grow>
            <FormInput
              style={{
                boxShadow: "none",
              }}
              type="text"
              value={this.state.q}
              onChange={this.handleSearchChange}
              placeholder={translate('products.search')}/>
          </InputGroup.Section>
        </InputGroup>
      </Form>
    )
  }
}

export default SearchBar



// WEBPACK FOOTER //
// ./src/components/Search/SearchBar.js